import {
  beforeSaveIncomplete,
  defaultItem,
  defaultValues,
  save,
  askForDelete,
  deleteItem,
  setDefault,
  var_type,
  ask_for_toggle,
  toggle_item,
  /* thenGetRows,
  getRows, */
} from './CrudMethodsV1.js';
import { recursiveCopy } from '@/functions/general.js';
export default {
  mixins:[],
  props:{
    items:{default:()=>[]},

    logic_delete_key:{default:'is_deleted'},
    merge_new_item:{default:null},
      flds:{default:()=>[]},
    beforeSaveIncomplete:{
      default: () => beforeSaveIncomplete,
    },
    logicDelete:{default:true},
      beforeSetRows:{},
    addItemAndSave:{default:false},
    canAdd:{default:true},
    canDelete:{default:true},
    canWrite:{default:true},
    canDetail:{default:true},
    afterSave:{},
    afterDeleting:{},
    after_toggle:{},
    beforeSelecting:{},
    afterSelecting:{},
    beforeSave:{},
    customPatch:{},
    customPost:{},
    customDelete:{},
    dialogWriteWdith:{},
    /* name:{}, */
    onOpenDetail:{},
    scheme:{},
    rowsFunction: {},
    new_item_get_id:{default:false},
    /* no_filter:{default:false}, */
    /* st_key:{}, */
    /* customGet:{},
    customGets:{}, */
    /* preFilters:{}, */
  },
  data() {
    return {
      toggle_key:null,
      toggle_dialog: false,
      dialogDetail: false,
      dialogWrite: false,
      dialogCustom: false,
      deleteDialog: false,
      selectedItem: {},
      rows: [],
      defaultValues,
      new_id:null,
    };
  },
  computed: {
    schemeNotNull(){
      const ret = {};
      this.dev_log(this.scheme);
      if (this.scheme) {
        Object.keys(this.scheme)
          .filter(k => this.scheme[k].notNull)
          .forEach(k => ret[k] = this.scheme[k]);
      }
      return ret;
    },
    patch() { return this.requests.patch[this.customPatch] || this.requests.patch[this.name_single_computed] },
    post() { return this.requests.post[this.customPost] || this.requests.post[this.name_all_computed] },
    delete() { return this.requests.delete[this.customDelete] || this.requests.delete[this.name_single_computed] },
    computedRows() { return this.rowsFunction ?this.rowsFunction(this.rows):this.rows },

    /* rq_filters() {
      if (!this.myRequestStatus) return null;
      return this.myRequestStatus.filter;
    }, */
    /* filters(){ return Object.assign({}, (this.preFilters || {}), this.defaultFilters, this.rq_filters) }, */
    /* slot_key(){ return this.myRequestStatus.slot_key }, */
    /* gets() { return this.requests.gets[this.customGets] || this.requests.gets[this.name_all_computed] }, */
    /* get() { return this.requests.get[this.customGet] || this.requests.get[this.name_single_computed] }, */
    /* requestStatus_status(){ return this.myRequestStatus.status}, */
  },
  watch:{
    'items'(p){ this.set_rows(p) },
    /* 'requestStatusRq'(v){ v.then && v.then(r => this.thenGetRows(r)) }, */
  },
  /* beforeDestroy(){ this.myRequestStatus.active = false }, */
  created(){
    this.set_rows(this.items);
    /* if (this.gets_on_created) {
      if (!this.created_cache) {
        this.myRequestStatus.status = false;
        this.myRequestStatus.ticking = false;
      }
      if (!this.requestStatusRq.then) this.getRows();// si tiene, es pq los filtros se ejecutaron antes
      if (this.requestStatusRq.then && this.myRequestStatus.status) this.requestStatusRq.then(r => this.thenGetRows(r))
      else if (!this.pagination) this.getRows()
      else if (this.no_filter) this.getRows();
    }
    this.myRequestStatus.active = true; */
  },
  methods: {
    defaultItem,
    set_rows(p){ this.rows = p || []},
    var_type,
    setDefault,
    getDefaultValue(d){ return typeof d === 'function' ?  d(): d },
    closeDialogWrite(){ this.dialogWrite = false },
    closeDialogCustom(){ this.dialogCustom = false },
    save,
    writeItem(item) { this.seletectItem(item, ()=>this.dialogWrite = true) },
    itemDetail(item){
      this.seletectItem(item);
      this.dialogDetail = true;
      if(this.onOpenDetail) this.onOpenDetail(item, this.rows)
    },
    newItem(){
      this.selectedItem = this.defaultItem();
      if (this.merge_new_item) Object.assign(this.selectedItem,this.merge_new_item);
      this.dialogWrite = true;
      if (this.afterSelecting) this.afterSelecting(this.selectedItem);
      if(this.addItemAndSave) this.save();
      if (this.new_item_get_id) this.post().then(r=>{
        Object.assign(this.selectedItem,r);
        if (this.merge_new_item) Object.assign(this.selectedItem,this.merge_new_item);
        this.new_id = r.id;
        return r;
      });
    },
    check_and_save(){
      if (!this.beforeSaveIncomplete()) return false;
      this.dialogWrite = false;
      this.save()
    },
    askForDelete,
    deleteItem,
    ask_for_toggle,
    toggle_item,
    /* async  */seletectItem(item,call) {
      /* if (this.get) {
        this.setProgress({show:true,message:'Cargando...'});
        this.get(item.id)
          .then(r => {
            this.setProgress({show:false});
            if (r.id) {
              this.setDefault(r);
              if (this.beforeSelecting) this.beforeSelecting(r);
              this.selectedItem = r;
              if (this.afterSelecting) this.afterSelecting(r);
            } else {
              this.closeDialogWrite();
              this.getError('customGet',r);
            };
            if (call) call();
          })
          .catch(e => this.closeDialogWrite() || this.getError(e));
      } else { */
      if (this.beforeSelecting) this.beforeSelecting(item);
      this.selectedItem = recursiveCopy(item);//{...item};
      if (this.afterSelecting) this.afterSelecting(item);
      if (call) call();
    //}
    },
    /* thenGetRows, */
    /* getRows, */
    /* request(){
      this.resetRqStatus();
      return this.getRows();
    }, */
/*     resetRqStatus(){
      this.myRequestStatus.status = 2;
      this.myRequestStatus.ticking = false;
    }, */
  },
};
